import { SaveIndicator } from "./autosave-form/SaveIndicator";
import { useSaveIndicator } from "@/hooks/useSaveIndicator";
import { Row } from "@/components";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

import { cn } from "@/lib/utils";

export const IntakeBoolean = ({
  checked,
  className,
  label,
  onToggle,
}: {
  checked: boolean | null | undefined;
  className?: string;
  label: string;
  onToggle: () => Promise<void> | void;
}) => {
  const { status, trigger } = useSaveIndicator();

  return (
    <div className={cn("min-w-0", className)}>
      <Row className="mb-1.5 items-center justify-between gap-1 pr-8">
        <Label className="min-w-0 truncate text-sm font-medium text-slate-700">
          {label}
        </Label>
        <SaveIndicator status={status} />
      </Row>
      <Row className="items-center gap-2">
        <Switch
          checked={!!checked}
          onCheckedChange={() => {
            trigger(onToggle());
          }}
        />
        <span className="text-sm text-slate-600">{checked ? "Yes" : "No"}</span>
      </Row>
    </div>
  );
};
